
import { CircularProgress } from "@mui/material";
import React from 'react'
// import { useNavigate } from 'react-router-dom'
import SideNavLayout from 'src/components/layouts/SideNavLayout/SideNavLayout'
import useAccessModule from 'src/hooks/useAccessModule'
import useLocalStorageData from 'src/hooks/useLocalStorageData'
const Welcome = () => {
    const { AuthToken } = useLocalStorageData()
    const {  userAccessIsloading } = useAccessModule();
    if (userAccessIsloading) {
        // Show loading spinner if user access data is not available yet
        return (
          <div className="flex justify-center  items-center w-screen h-screen bg-white">
            <CircularProgress />
          </div>
        );
      }

    const handleToLogin =()=>{
      window.location.pathname="/"
    }
    return (
        <>
            {AuthToken ? (<SideNavLayout>
                < div className='flex justify-center py-5' >
                    Welcome to geeksdoor
                </div >
            </SideNavLayout >) : handleToLogin() }
        </>
    )
}

export default Welcome